import { ComingSoon } from '../components/ComingSoon';

export function AnalyticsPage() {
  return (
    <ComingSoon
      title="Analytics"
      phase="Phase 4"
      summary="Landing-page UTM funnel (visits → install-page → bot-add deep-link click). Reuses the website's existing UTM capture, extended with bot-side correlation via the /start deep-link payload."
      bullets={[
        'Total visits, unique visitors, top campaign / top source — with date range toggle',
        'Top campaigns table with first-seen and last-seen timestamps; click to filter',
        'Top sources bar chart',
        'utm_content breakdown (visible only when filtered to a single campaign)',
        'Bot-add correlation: which install-page CTAs converted to actual /start events'
      ]}
    />
  );
}
